<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>

            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>

                        <template #cell(importo)="item">
                            <span> {{ item.item.importo + "€" }}</span>
                        </template>

                        <template #cell(descrizioneIva)="item">
                            <span> {{ item.item.descrizioneIva }}</span>
                        </template>

                        <template #cell(aliquotaIva)="item">
                            <span>{{ formatPercentage(item.item.aliquotaIva) }}</span>
                        </template>

                        <template #cell(spesaRicorsiva)="item">
                            <span v-if="item.item.spesaRicorsiva"> SI</span>
                            <span v-else> NO</span>
                        </template>

                        <template v-slot:cell(eventi)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica Spesa Extra" variant="outline-success" @click="onClickEdit(item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Cancella Spesa Extra" variant="outline-danger" @click="onDeleteSpesaExtra(item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>

                <rsa-configurazione-spese-extra-edit-component ref="cmpRsaConfigurazioneSpeseExtraEditComponent" @onSave="loadData" @closeModal="loadData" @spesaExtraDelete="loadData" />
            </div>

            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazioneSpeseExtraEditComponent from "./RsaConfigurazioneSpeseExtraEditComponent.vue";

export default {
    components: { RsaConfigurazioneSpeseExtraEditComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsaspeseextra",
            listKey: 0,
            items: [],
            filtroSpeseExtra: { nome: null },
            btnNuovaPrestazioneHidden: false,
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                },
                {
                    label: "Spesa",
                    key: "descrizione",
                    sortable: false,
                },
                {
                    label: "Importo",
                    key: "importo",
                    sortable: false,
                },
                {
                    label: "Nat. Fiscale",
                    key: "descrizioneIva",
                    sortable: false,
                },
                {
                    label: "Aliquota IVA",
                    key: "aliquotaIva",
                    sortable: false,
                },
                {
                    label: "Spesa Ricorsiva",
                    key: "spesaRicorsiva",
                    sortable: false,
                },
                {
                    label: "Note",
                    key: "note",
                    sortable: false,
                },

                {
                    class: "sa-table-column-action-double",
                    key: "eventi",
                    label: "",
                },
            ],
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroSpeseExtra"]) {
                me.filtroSpeseExtra = JSON.parse(sessionStorage["filtroSpeseExtra"]);
                me.$emit("updateFilter", me.filtroSpeseExtra);
                // console.log("filtroSpeseExtra", me.filtroSpeseExtra);
            }

            let filtro = { ...me.filtroSpeseExtra, forPage: me.perPage, page: me.currentPage };

            UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            /* console.log("LOADDATASUCCESS", response.data.data.list); */

            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            //da domandare se va bene qui
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData");
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
        },

        onClickView(items) {
            let me = this;
            me.$router.push("/rsaspeseextra/view/" + items.id);
        },
        onClickEdit(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazioneSpeseExtraEditComponent.show(item);
        },
        nuovaSpesaExtra() {
            let me = this;
            me.$refs.cmpRsaConfigurazioneSpeseExtraEditComponent.show({
                id: null,
                descrizione: null,
                naturaEconomica: "",
                codiceIva: null,
                descrizioneIva: null,
                spesaRicorsiva: false,
                importoLibero: false,
                includiFattura: false,
                nonAggregare: false,
                note: null,
            });
        },
        onDeleteSpesaExtra(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazioneSpeseExtraEditComponent.onDeleteSpesaExtra(item);
        },
        formatPercentage(value) {
            return value ? value.toFixed(2) : "0.00";
        },
    },
};
</script>
